const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="max-w-md text-center">
        <h1 className="text-8xl font-extrabold text-primary mb-4 animate-fade-in-down">
          404
        </h1>
        <h2 className="text-3xl text-primary sm:text-4xl font-bold mb-4 animate-fade-in-up">
          Page Not Found
        </h2>
        <p className="text-lg text-muted-foreground mb-8 animate-fade-in">
          Oops! The page you're looking for doesn't exist. It might have been
          moved or deleted.
        </p>
      </div>
    </div>
  );
};

export default NotFoundPage;
